export const getAmendmentsApi = (params, query) => {
  const queryString = new URLSearchParams(query).toString();
  return `lease/${params?.leaseSlug}/amendment${queryString ? `?${queryString}` : ''}`;
};
export const getAmendmentsDetailApi = (params) => {
  return `lease/${params?.leaseSlug}/amendments`;
};
export const addAmendmentsApi = (params) => {
  return `lease/${params?.leaseSlug}/amendment`;
};
export const updateAmendmentsApi = (params) => {
  return `lease/${params?.leaseSlug}/amendment/${params?.slug}`;
};
export const deleteAmendmentsApi = (params) => {
  return `lease/${params?.leaseSlug}/amendment`;
};

export const exportAmendmentsApi = (leaseId) => {
  return `lease/${leaseId}/amendments`;
};

export const amendmentfileUploadPostApi = (supplement_slug) => {
    return `/get-pre-signed-url/amendment/${supplement_slug}`;
};

export const amendmentachmentMetaData=(attachments_slug)=>{
    return `update-attachment-metadata/amendment/${attachments_slug}`
}